"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pciExternalStatusToBlockEmails = void 0;
var pciExternalStatusToBlockEmails;
(function (pciExternalStatusToBlockEmails) {
    pciExternalStatusToBlockEmails["GRAY_LISTED"] = "GrayListed";
    pciExternalStatusToBlockEmails["HARD_BOUNCE"] = "HardBounce";
    pciExternalStatusToBlockEmails["INVALID_EMAIL_ADDRESS"] = "InvalidEMailAddress";
    pciExternalStatusToBlockEmails["SOFT_BOUNCE"] = "SoftBounce";
    pciExternalStatusToBlockEmails["BLACK_LISTED"] = "BlackListed";
    pciExternalStatusToBlockEmails["SPAM_REPORT"] = "SpamReport";
})(pciExternalStatusToBlockEmails || (exports.pciExternalStatusToBlockEmails = pciExternalStatusToBlockEmails = {}));
